export default __webpack_public_path__ + "static/media/ge.eb8f0e1f.svg";